import Vue from 'vue';
import Router from 'vue-router';
import qs from 'qs';
import { getUnionId } from '@/api/api';
import { isWeiXin, isMobile } from '@/common/ts/common';
import SyActivityDemo from './views/samples';
import KFLJ20200929 from '@/views/20200929KFLJ';
import HCJ20201014 from '@/views/20201014HCJ';
import GTFSB20201023 from '@/views/20201023GTFSB';
import QSNJJ20201109 from '@/views/20201109QSNJJ';
import DSPDS20201130 from '@/views/20201130DSPDS';
import STSQ20201127 from '@/views/20201127STSQ';
import SHZPB20201203 from '@/views/20201203SHZPB';
import GTFSB220201204 from '@/views/20201204GTFSB2';
import WMSJKBY20201208 from '@/views/20201208WMSJKBY';
import NEWEXPECTATION20201211 from '@/views/20201211NEWEXPECTATION';
import CQZQ20201211 from '@/views/20201211CQZQ';
import DSPZS20201218 from '@/views/20201218DSPZS';
import JTYM20201225 from '@/views/20201225JTYM';
import BYZM20201224 from '@/views/20201224BYZM';
import CDWMHJZS20201231 from '@/views/20201231CDWMHJZS';
import GPYJ20210121 from '@/views/20210121GPYJ';
import GZLDZ20210115 from '@/views/20210115GZLDZ';
import LHREPORT20210115 from '@/views/20210115LHREPORT';
import ZWBS20210122 from '@/views/20210122ZWBS';
import LHLLK20210120 from '@/views/20210120LHLLK';
import ZLCZ20210123 from '@/views/20210123ZLCZ';
import ZOOLIVE20210129 from '@/views/20210129ZOOLIVE';
import ZRTS20210209 from '@/views/20210209ZRTS';
import BaShuTwo20210202 from '@/views/20210202BaShuTwo';
import JiLiMovie20210209 from '@/views/20210209JiLiMovie';
import PlaceTop520210223 from '@/views/20210223PlaceTop5';
import QGLH20210302 from '@/views/20210302QGLH';
import CQHSN20210315 from '@/views/20210315CQHSN';
import JTYMZS20201225 from '@/views/20201225JTYMZS';
import JKZG20210315 from '@/views/20210315JKZG';
import RedAndBlack20210315 from '@/views/20210315RedAndBlack';
import WXKTZW20210317 from '@/views/20210317WXKTZW';
import CCPXZC20210313 from '@/views/20210313CCPXZC';
import JJRWPX20210323 from '@/views/20210323JJRWPX';
import SDFWPP20210319 from '@/views/20210319SDFWPP';
import LJH20210329 from '@/views/20210329LJH';
import REDSTORY20210326 from '@/views/20210326REDSTORY';
import ZMGZ20210322 from '@/views/20210322ZMGZ';


Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: () => import('@/views/HelloWorld.vue'),
    },
    // Demo展示
    SyActivityDemo,
    // 开放两江，智慧之城
    KFLJ20200929,
    // 仁孚奔驰19换车节
    HCJ20201014,
    // 上游新闻“跟帖封神榜”
    GTFSB20201023,
    // 2020青少年击剑竞标赛
    QSNJJ20201109,
    // 重庆市“粒粒皆辛苦”青少年短视频大赛
    DSPDS20201130,
    // +直播 见未来---2020社群生态大会
    STSQ20201127,
    // 2020上游生活总评榜
    SHZPB20201203,
    // 上游新闻跟帖封神榜第二季
    GTFSB220201204,
    // 文明实践看巴渝
    WMSJKBY20201208,
    // 2020重庆新期待
    NEWEXPECTATION20201211,
    // 我心目中的重庆队
    CQZQ20201211,
    // 重庆市“粒粒皆辛苦”青少年短视频大赛
    DSPZS20201218,
    // 寻根乡愁 记住年味
    JTYM20201225,
    // 打卡巴渝之美
    BYZM20201224,
    // 吃得文明获奖作文展示
    CDWMHJZS20201231,
    // “光盘有奖 咖啡留香”吃得文明劝导活动
    GPYJ20210121,
    // 2021年“为川渝高质量点赞”消费品（服务） 评价展示活动
    GZLDZ20210115,
    // 2021重庆两会特别报道
    LHREPORT20210115,
    // &quot;观经典作品 传红色基因&quot;征文比赛
    ZWBS20210122,
    // 2021重庆两会连连看
    LHLLK20210120,
    // 第二课堂 助力成长
    ZLCZ20210123,
    // 乐和乐都动物视频直播活动
    ZOOLIVE20210129,
    //  渝港澳青少年自然探索大赛公益活动
    ZRTS20210209,
    // 北新巴蜀中学师生艺术联展第二期
    BaShuTwo20210202,
    // 吉利异业互动活动
    JiLiMovie20210209,
    // “牛年新春 重庆潮玩圣地TOP5”评选活动
    PlaceTop520210223,
    // 启航2021·全国两会特别报道
    QGLH20210302,
    // 2021年“新时代重庆好少年”候选展示
    CQHSN20210315,
    // 九童圆梦牛年春节行动
    JTYMZS20201225,
    // jkzg
    JKZG20210315,
    // jdk
    RedAndBlack20210315,
    // 文心课堂作文活动
    WXKTZW20210317,
    // 奋斗百年路·启航新征程
    CCPXZC20210313,
    // jjrwpx
    JJRWPX20210323,
    // jsjdf
    SDFWPP20210319,
    // 第二届春季线上旅交会
    LJH20210329,
    // 红色故事云端晒
    REDSTORY20210326,
    // 春满渝州·最美高职
    ZMGZ20210322,
    {
      path: '*',
      name: 'not-found',
      component: () => import('@/views/NotFound/Home.vue'),
    },
  ],
  // 跳转后回到顶部
  scrollBehavior(to, from, savedPosition): any {
    return to.meta.keepPosition
      ? {}
      : {
          x: 0,
          y: 0,
        };
  },
});

router.beforeEach(async (to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  // 以下操作均在微信环境中生效
  if (!isWeiXin()) {
    next();
    return;
  }
  const { code } = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  });
  // 控制微信授权是否启用
  if (to.meta.customWeChatAuth) {
    console.log('第三方公众号, 不默认拉取用户信息');
  } else if (code && !localStorage.getItem('unionid')) {
    console.log('request wx user info');
    const res: any = await getUnionId({ code });
    if (res.code === 200) {
      console.log('res.data878738475o3874', res.data);
      window.localStorage.setItem('unionid', res.data.openId);
      window.localStorage.setItem('nickname', res.data.nickname);
      window.localStorage.setItem('headimgurl', res.data.headimgurl);
      // 应将用户微信信息整体存入localStorage
      localStorage.setItem('syWeChatUserInfo', JSON.stringify(res.data));
    } else {
      console.log('清理过期的code');
      // !query中清理过期code字段, 防止用户分享携带有自己的code的页面给其他人，导致无法进行授权登录的状况
      const queries = to.query;
      let strings = '';
      Object.keys(queries).forEach((item: any) => {
        if (item !== 'code') {
          strings += `${item}=${queries[item]}&`;
        }
      });
      strings = strings.slice(0, strings.length - 1);
      location.href = `${window.location.origin}${window.location.pathname}?${strings}`;
    }
  } else {
    console.log('例外');
  }
  next();
});

router.onError((error) => {
  // PC微信解析一个异步组件异常时错误收集
  if (isWeiXin() && !isMobile()) {
    const el = document.createElement('p');
    el.innerHTML = '请复制链接在Chrome, QQ, 360极速/安全等现代浏览器中打开';
    el.style.textAlign = 'center';
    document.body.innerHTML = '';
    document.body.appendChild(el);
  }
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = (router as Router & { history: any }).history.pending
    .fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});

export default router;
